import React from 'react'
import moment from 'moment'
import { Modal, Label } from 'semantic-ui-react'
import { formatCurrency } from '../../../utils/commonutils'

const HEADER_CONFIG = {
  familyView: { title: 'Patient Family View' },
  familyCapacityView: { title: 'Forward Capacity View' },
  goxDetailsList: (doctorName, contractType, startDate) => ({
    title: `${doctorName} X-Ray ${contractType} (${moment(startDate).format('MMMM YYYY')})`
  }),
  collectionList: (doctorName, contractType, startDate) => ({
    title: `${doctorName} ${contractType} (${moment(startDate).format('MMMM YYYY')})`
  }),
  nextDays: (nextDaysObj) => ({ title: nextDaysObj.heading })
}

const REPORT_HEADINGS = {
  production: 'bCARE Report',
  adjustment: 'Adjustments',
  writeoff: 'Write Offs',
  payStub: 'Earnings Report',
  gox: 'Gox Report',
}

const ModalHeader = (props) => {
  const { detailsModalType, contractType, doctorName, startDate, nextDaysObj, earningsReportOptions, eventClick, eventDate, detailsModal, reportTotal } = props;
  const isPayStubWithEarnings =
    detailsModalType === 'payStub' &&
    Object.keys(earningsReportOptions).length &&
    earningsReportOptions[contractType]

  if (isPayStubWithEarnings) {
    return (
      <Modal.Header>
        CDP Dentist's Pre-Tax Earning's Summary{' '}
        <span className='text-pay-contractName'>({contractType})</span>
      </Modal.Header>
    )
  }

  const headerConfig = HEADER_CONFIG[detailsModalType]

  if (headerConfig) {
    const config = typeof headerConfig === 'function'
      ? headerConfig(doctorName, contractType, startDate, nextDaysObj)
      : headerConfig

    return <Modal.Header>{config.title}</Modal.Header>
  }

  const heading = REPORT_HEADINGS[detailsModalType]
  const dateLabel = eventClick === 'month'
    ? moment(startDate).format('MMM-YYYY')
    : moment(eventDate).format('MM/DD/YY')

  const totalColor = detailsModalType === 'writeoff' ? 'purple' : 'blue'

  return (
    <Modal.Header>
      <Label content={doctorName} color="blue" className="mr10" />
      {heading} {detailsModal === 'details' ? 'Details' : ''} ({dateLabel})
      {reportTotal != null && (
        <Label
          basic
          color={totalColor}
          detail={heading}
          content={formatCurrency(reportTotal)}
          className="ml10"
        />
      )}
    </Modal.Header>
  )
}

export default ModalHeader
